export default __webpack_public_path__ + "static/adults-product-1-abf46caa769f3327168878a7a6a772e8.png";